import Header from "./components/Layout/Header";
import { ApiProvider, BalanceProvider, WalletProvider } from "./contexts";
import HomePage from "./pages/homePage/HomePage";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <ApiProvider>
      <WalletProvider>
        <BalanceProvider>
          <div className="min-h-screen bg-darkBg after:h-[560px] after:w-[560px] after:bg-shapebg after:absolute after:-top-[385px] after:opacity-60 after:[filter:blur(400px)]   after:left-1/4 after:rounded-full  relative">
            <Toaster
              position="top-right"
              reverseOrder={false}
              gutter={8}
              containerClassName=""
              containerStyle={{}}
              toastOptions={{
                className: "p-5 flex items-center",
                duration: 5000,
                removeDelay: 1000,
              }}
            />
            <Header />
            <HomePage />
            
          </div>
        </BalanceProvider>
      </WalletProvider>
    </ApiProvider>
  );
}

export default App;
